const setPublisherId = hashedCustomerId => {
  if (hashedCustomerId) {
    window.googletag.pubads().setPublisherProvidedId(hashedCustomerId);
  }
};

export default setPublisherId;
